export enum PresetElementType {
    SHAPE = 'shape',
    IMAGE = 'image',
    TEXT = 'text',
}
